import {TscButtonType, EmptyState, TscThemeName, TscThemeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';
import React, {MouseEventHandler} from 'react';
import styled from 'styled-components';
import cssConstants from '../../constants/cssConstants';

export const StatusContentWrapper = styled.div<{theme: TscThemeNames}>`
   display: flex;
   flex: 1 1 auto;
   padding-top: 2rem;
   background: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.dark : cssConstants.dawnPageBackgroundColor};

   img {
      display: none;
   }

   @media screen and (min-height: 360px) {
      img {
            display: inline-block;
         }
      }
   }
`;

const Status: React.FC<IStatusProps> = ({buttonText, imageAlt, imageSrc, onButtonClick, text, title}) => (
   // The theme is being forced to dawn because some of the status images have terrible contrast with the dusk theme.
   // TODO: Get new SVG images from UX and re-enable dusk theme support
   <StatusContentWrapper theme={TscThemeName.dawn}>
      <EmptyState
         alt={imageAlt}
         imageSource={imageSrc}
         maxWidth="100%"
         onPrimaryClick={onButtonClick}
         primaryButtonText={buttonText}
         primaryButtonType={TscButtonType.primary}
         text={text}
         title={title}
         themeName={TscThemeName.dawn}
      />
   </StatusContentWrapper>
);

export default Status;

export interface IStatusProps {
   buttonText?: string;
   imageAlt?: string;
   imageSrc?: string;
   onButtonClick?: MouseEventHandler;
   text?: any;
   title?: string;
}